<template>
    <img v-if="name === 'white'" class="logo w-[150px] h-[100]" src="/images/logo_white_mcc.png" alt="Logo">
    <img v-else class="logo w-[180px] h-auto" src="/images/logo.png" alt="Logo" />
</template>
<script>
export default {
    props: {
        name: String,
    },
}
</script>
